import React from 'react';
import PropTypes from 'prop-types';
import Label from "semantic-ui-react/dist/es/elements/Label/Label.js";
import { KEY_FACTS } from "../../../utils/default-strings";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { Heading } from "../../typography/Heading";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { IconCard } from "../../elements/IconCard";
export var Component = function Component(_ref) {
  var keyFacts = _ref.keyFacts,
      headingText = _ref.headingText;
  return React.createElement(Grid, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, null, headingText)), React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Label.Group, null, keyFacts.map(function (_ref2, index) {
    var iconName = _ref2.iconName,
        isDisabled = _ref2.isDisabled,
        label = _ref2.label;
    return React.createElement(IconCard, {
      isDisabled: isDisabled,
      isFilled: true,
      key: buildKeyFromStrings(label, index),
      label: label,
      name: iconName
    });
  }))));
};
Component.displayName = 'KeyFacts';
Component.defaultProps = {
  headingText: KEY_FACTS
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  headingText: PropTypes.string,
  keyFacts: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    label: PropTypes.string.isRequired
  })).isRequired
} : {};